(() => {
  const id = "xencms:form";

  Drupal.behaviors[id] = { attach: (context, settings) => {
    once(id, ".field__suffix", context).forEach((suffix) => {
      const input = suffix.parentElement.querySelector(".field__input");
      if (!(input instanceof Element)) return;

      const width = suffix.clientWidth;
      const paddingRight = width + 30;
      input.style.paddingRight = `${paddingRight}px`;
    });
  }};
})();
